/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseCompletedEvent = {
  type: "response.completed";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseCompletedEvent$inboundSchema: z.ZodType<
  ResponseCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.completed"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseCompletedEvent$Outbound = {
  type: "response.completed";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseCompletedEvent$outboundSchema: z.ZodType<
  ResponseCompletedEvent$Outbound,
  z.ZodTypeDef,
  ResponseCompletedEvent
> = z.object({
  type: z.literal("response.completed"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseCompletedEventToJSON(
  responseCompletedEvent: ResponseCompletedEvent,
): string {
  return JSON.stringify(
    ResponseCompletedEvent$outboundSchema.parse(responseCompletedEvent),
  );
}
export function responseCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseCompletedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseCompletedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseCompletedEvent' from JSON`,
  );
}
